/**
 * Группа chip-фильтров для одного измерения (Цвет / Форма / Подкатегория).
 *
 * Чисто презентационный компонент (см. ADR-0005). Вся async-логика
 * — в Container. UI-инварианты: вертикальное расположение групп, chip click
 * target ≥48px, aria-pressed на каждом chip, aria-label «<Группа>: <Значение>» (P-022).
 */
export interface FilterChipsProps {
  groupLabel: string;
  values: readonly string[];
  selected: readonly string[];
  onToggle: (value: string) => void;
  onResetGroup: () => void;
}

export function FilterChips({
  groupLabel,
  values,
  selected,
  onToggle,
  onResetGroup,
}: FilterChipsProps) {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <span className="font-display text-filter-label text-ink">{groupLabel}</span>
        <button
          type="button"
          onClick={onResetGroup}
          aria-label={`Сбросить выбор: ${groupLabel}`}
          className="bg-transparent text-muted underline text-base"
        >
          Сбросить
        </button>
      </div>
      {/* Плотная упаковка (Этап 3 #2, шаблон «Фильтр ручки»): flex-wrap контейнер +
          flex-auto (flex: 1 1 auto) на чипе → чипы растягиваются по ширине ряда,
          ряды заполняются полностью, ровные правые края без «дыр» справа. */}
      <div className="flex flex-wrap gap-2">
        {values.map((value) => {
          const isSelected = selected.includes(value);
          return (
            <button
              key={value}
              type="button"
              aria-pressed={isSelected}
              aria-label={`${groupLabel}: ${value}`}
              onClick={() => onToggle(value)}
              className={[
                'flex-auto min-h-tap-chip-lg px-4 rounded-chip text-chip transition-colors',
                'focus-visible:ring-2 focus-visible:ring-cta focus-visible:outline-none',
                isSelected
                  ? 'bg-chip-selected text-white border-[1.5px] border-chip-selected'
                  : 'bg-card text-ink border-[1.5px] border-accent active:opacity-90',
              ].join(' ')}
            >
              {value}
            </button>
          );
        })}
      </div>
    </div>
  );
}
